<template>
  <div class="m-grid__item m-grid__item--order-tablet-and-mobile-2 m-login__aside">
    <div class="m-stack m-stack--hor m-stack--desktop">
      <div class="m-stack__item m-stack__item--fluid">
        <div class="m-form">
          <div class="m-login__logo">
            <img src="/media/img/logo_superaccess.png">
          </div>
          <s-alert v-if="alert" :body="text_body" :alertType="alert_class"></s-alert>
          <div class="m-login__signin">
            <div class="m-login__head">
              <h3 class="m-login__title">
                {{ title | capitalize }}
              </h3>
              <div class="m-login__desc">
                {{ 'assign_password_text' | capitalize }}
              </div>
            </div>
            <br>
            <form class="m-login__form m-form" action="">
              <div class="form-group m-form__group has-danger">
                <input v-validate="'required|email|min:4|max:100'" v-model="data.email" name="email" :class="{'input': true, 'danger': errors.has('email') }" class="form-control m-input" type="text" id="email"  autocomplete="off" ref="emai" disabled>
                <span v-show="errors.has('email')" class="form-control-feedback">{{ errors.first('email') }}</span>
              </div>
              <label>{{ 'new_password' | capitalize }}</label>
              <div class="form-group m-form__group has-danger">
                <input v-validate="'required|min:6|confirmed:password'" pattern="^((?=.*\W+)(?=.*[a-zA-Z])(?=.*[0-9]).{6,})$" v-model="data.password" :class="{'input': true, 'danger': errors.has('password') }" class="form-control m-input m-login__form-input--last" id="password" type="password" :placeholder="'new_password' | capitalize" name="password" ref="password">
                <span v-show="errors.has('password')" class="form-control-feedback">{{ errors.first('password') }}</span>
              </div>
              <label style="font-size:14px;"><small>{{ 'password_conditions' | capitalize }}</small></label>
              <label>{{ 'confirm_password' | capitalize }}</label>
              <div class="form-group m-form__group has-danger">
                <input v-validate="'required|min:6|confirmed:password'" pattern="^((?=.*\W+)(?=.*[a-zA-Z])(?=.*[0-9]).{6,})$" v-model="data.confirm_password" :class="{'input': true, 'danger': errors.has('confirm_password') }" class="form-control m-input m-login__form-input--last" id="rePassword" type="password" :placeholder="'confirm_password' | capitalize" name="confirm_password" data-vv-as="password" ref="rePassword">
                <span v-show="errors.has('confirm_password')" class="form-control-feedback">{{ errors.first('confirm_password') }}</span>
              </div>
              <br>
              <div class="m-login__form-action">
                <button id="btn-assign" @click.prevent="assign()" class="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air">
                  {{ btn_txt | capitalize }}
                </button>
                <router-link :to="{ name: 'login' }" class="btn btn-outline-focus m-btn m-btn--pill m-btn--custom m-btn--air">
                  {{'cancel' | capitalize}}
                </router-link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SAlert from '@/components/layout/alert/Alert.vue'
export default {
  components: { SAlert },
  created () {
    console.log('assssign')
    this.$spinner.show()
    this.data.link_id = this.$route.params.id
    this.title = this.$route.meta.title
    this.btn_txt = this.$route.meta.btn_txt
    this.data.email = this.$route.params.email
    this.$store.dispatch('postValidateLink', this.$route.params.id)
      .then((res) => {
        this.$spinner.remove()
        if (res.data.user_id) {
          this.data.user_id = res.data.user_id
          this.data.email = res.data.email
        } else if (res.data.status === 400) {
          console.log('assssign else')
          this.$router.push({
            name: 'login',
            params: { code: 400, message: res.data.message }
          })
        }
      })
      .catch((err) => {
        this.alert = true
        this.text_body = this.$options.filters.capitalize('validate_link_error')
        this.alert_class = 'alert-danger'
        this.$spinner.remove()
        console.log(err)
      })
  },
  data () {
    return {
      data: {
        password: '',
        confirm_password: '',
        user_id: '',
        link_id: '',
        email: ''
      },
      title: '',
      btn_txt: '',
      alert: false,
      text_body: '',
      alert_class: ''
    }
  },
  methods: {
    assign () {
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            var hostname = window.location.hostname
            var port = window.location.port
            var url = ''
            if (port === '3000') {
              // Desarrollo
              url = 'http://' + hostname + ':' + port + '/login'
            } else {
              // Producción
              url = 'https://' + hostname + ':' + port + '/login'
            }
            this.$spinner.show()
            if (this.data.user_id) {
              this.$store.dispatch('potAssignPassword', this.data)
                .then((res) => {
                  this.$spinner.remove()
                  if (res.data.status === 200) {
                    this.$store.dispatch('postLogin', [this.data.email, this.data.password])
                      .then((response) => {
                        this.$toast('welcome_message', 1, 400)
                        window.location.href = url
                      })
                  } else {
                    this.$router.replace({path: 'login'})
                  }
                })
                .catch((err) => {
                  this.alert = true
                  this.text_body = this.$options.filters.capitalize('assign_password_error')
                  this.alert_class = 'alert-danger'
                  console.log(err)
                })
            } else {
              this.alert = true
              this.text_body = this.$options.filters.capitalize('invalid_link_message')
              this.alert_class = 'alert-danger'
            }
          }
        }, error => {
          console.log(error)
        })
    }
  },

  watch: {
    alert () {
      if (this.alert) {
        setTimeout(() => {
          this.alert = false
        }, 20000)
      }
    }
  }
}
</script>

<style scoped>
  #password {
    border-radius: 15px;
    border: 1px solid;
  }
 #email {
    border-radius: 15px;
    border: 1px solid;
 }
  #rePassword {
    border-radius: 15px;
    border: 1px solid;
  }
  #selectLogin {
    padding: 0px !important;
  }

  img {
    width: 200px;
  }

  .m-form {
    padding-top: 0px !important;
    text-align: center;
  }

  #btn-assign {
    background-color: #001644;
    border-color: #001644;
  }

</style>




// WEBPACK FOOTER //
// AssignPassword.vue